<div fxLayout="row">
    @if (toastRef.data.type == 'warning') {
        <fa-icon
            style="padding-top: 12px; font-size: 20px; color: #ffa000; font-weight: 900"
            [icon]="['fal', 'exclamation-circle']"></fa-icon>
    }
    @if (toastRef.data.type == 'success') {
        <fa-icon
            style="padding-top: 12px; font-size: 20px; color: #43a047; font-weight: 900"
            [icon]="['fal', 'check-circle']"></fa-icon>
    }
    @if (toastRef.data.type == 'info') {
        <fa-icon
            style="padding-top: 12px; font-size: 20px; color: #1976d2; font-weight: 900"
            [icon]="['fal', 'info-circle']"></fa-icon>
    }
    @if (toastRef.data.type == 'error') {
        <fa-icon
            style="padding-top: 12px; font-size: 20px; color: #b92b27; font-weight: 900"
            [icon]="['fal', 'times-circle']"></fa-icon>
    }
    <mat-accordion>
        <mat-expansion-panel
            [hideToggle]="!toastRef.data.detail"
            style="
                box-shadow: none !important;
                padding-left: 12px !important;
                padding-right: 12px !important;
                padding-bottom: 12px !important;
                padding-top: 12px !important;
            ">
            <mat-expansion-panel-header style="padding-bottom: 8px !important">
                @if (toastRef.data.title?.length > 0) {
                    <mat-panel-title>
                        <div [innerHTML]="toastRef.data.title | safeHtml"></div>
                    </mat-panel-title>
                }
                @if (toastRef.data.message?.length > 0) {
                    <mat-panel-description>
                        <div [innerHTML]="toastRef.data.message | safeHtml"></div>
                    </mat-panel-description>
                }
            </mat-expansion-panel-header>
            @if (toastRef.data.detail?.length > 0) {
                <div style="font-size: 14px; max-width: 600px" [innerHTML]="toastRef.data.detail | safeHtml"></div>
            }
        </mat-expansion-panel>
    </mat-accordion>
</div>
